import { render, staticRenderFns } from "./Weq.vue?vue&type=template&id=0180a438"
import script from "./Weq.vue?vue&type=script&lang=js"
export * from "./Weq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports